require('angular-ui-bootstrap');


var angular = require('angular');

var jsoneditor_module = angular.module('amt.jsoneditor', ['ui.bootstrap']);

// public
require('./resources/directive.js').default(jsoneditor_module);

require('./resources/modal.js').default(jsoneditor_module);
require('./resources/server.js').default(jsoneditor_module);

//templates
var tpl = require('./resources/modal.html');

jsoneditor_module.run(['$templateCache', function($templateCache) {
    $templateCache.put('amt.jsoneditor/modal.html', tpl);
}]);

export default jsoneditor_module.name;
